import React, { useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";

export default function MapMarker ({ pointId, point, onClick }) {

    const navigate = useNavigate();

    const [mapLocation, setMapLocation] = useState(null);

    const handleClick = function (event, point, pointId) {
        console.log("Clicked point", event, point, pointId);
        // if not locked and has a point Id
        if (!point.locked && typeof point !== "undefined" && typeof point.data.id !== "undefined") {
            navigate("/point/"+point.data.id);
        }
    }

    const getLocation = function(point) {
        let top = 0;
        let left = 0;

        if (point.data.map_location) {
            let data = point.data.map_location.split(',');
            if (data.length === 2) {
                top = data[0];
                left = data[1];
            }
        }

        if (top > 0 && left > 0) {
            return { top, left };
        }

        return null;
    }

    useEffect(() => {
        console.log(point);
        let hasPoint = (point) ? 'yes' : 'no';
        console.log("hasPoint: ",hasPoint);
        if (hasPoint) {
            let location = getLocation(point);
            console.log(location);
            setMapLocation(location);
        }
    }, [point]);

    // Load the point icon
    const [pointIcon, setPointIcon] = useState(null);
    React.useEffect(() => {
        if (point.data?.icon) {
            setPointIcon(point.data.icon.preview_url);
        }
    }, [point])

    if (mapLocation) {
        return (
            <div>

                <div key={pointId} style={{
                    position: "absolute",
                    left: mapLocation.left + "%",
                    top: mapLocation.top + "%",
                    width: "24px",
                    height: "24px",
                    margin: "-24px -12px 0",
                    backgroundImage: (pointIcon) ? "url('"+pointIcon+"')" : "url('/static/markers/default.svg')",
                    backgroundSize: "24px",
                    overflow: "hidden",
                    cursor: "pointer"
                }}
                     onClick={() => onClick(point.data, false)}
                >
                    <div>
                        {!point.data.icon && (
                            <div className="mapLabel">{point.data.order}</div>
                        )}

                    </div>
                </div>
            </div>
        );
    }

    return null;
}
